var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.role)?_c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive } ]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[(_vm.user.name)?_c('user-menu',{attrs:{"title":_vm.user}}):_vm._e(),_c('mobile-menu'),_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{ path: '/home', name: 'Home Page', icon: 'home' }}}),(_vm.user && _vm.check_object_value(_vm.user.role_name, 'name', ['Admin']))?_c('sidebar-item',{attrs:{"opened":_vm.check_object_value(_vm.user.role_name, 'division_id', [1])
            ? true
            : false,"link":{ name: 'Admin', icon: 'admin_panel_settings' }}},[(_vm.role['User'] && _vm.role['User'].menu == 1)?_c('sidebar-item',{attrs:{"link":{
            name: 'User Management',
            path: '/admin/user-management/list-users',
          }}}):_vm._e(),(_vm.role['Role'] && _vm.role['Role'].menu == 1)?_c('sidebar-item',{attrs:{"link":{
            name: 'Role',
            path: '/admin/role/list-role',
          }}}):_vm._e()],1):_vm._e(),(
          _vm.user &&
            _vm.check_object_value(_vm.user.role_name, 'division_id', [3, 1, 6, 8])
        )?_c('sidebar-item',{attrs:{"opened":_vm.check_object_value(_vm.user.role_name, 'division_id', [3])
            ? true
            : false,"link":{ name: 'DMS', icon: 'hub' }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Dashboard DMS',
            icon: 'dashboard',
            path: '/fms/dashboard',
          }}}),(
              _vm.role['FmsDrivers'] && _vm.role['FmsDrivers'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'Driver',
              path: '/Fms/list-driver',
            }}}):_vm._e(),(
              _vm.role['FmsPkos'] && _vm.role['FmsPkos'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'PKO',
              path: '/Fms/list-pko',
            }}}):_vm._e(),(
              _vm.role['FmsSpjs'] && _vm.role['FmsSpjs'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'SPJ',
              path: '/Fms/list-spj',
            }}}):_vm._e(),(
              _vm.role['FmsVehicles'] && _vm.role['FmsVehicles'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'Vehicle',
              path: '/Fms/list-vehicle',
            }}}):_vm._e(),(
              _vm.role['FmsCitys'] && _vm.role['FmsCitys'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'City',
              path: '/Fms/list-city',
            }}}):_vm._e(),(
              _vm.role['FmsDpAmounts'] && _vm.role['FmsDpAmounts'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'Dp Amount',
              path: '/Fms/list-dp-amount',
            }}}):_vm._e(),(
              _vm.role['FmsPaymentPlans'] && _vm.role['FmsPaymentPlans'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'Payment Plan',
              path: '/Fms/list-payment-plan',
            }}}):_vm._e(),(
              _vm.role['FmsCashiers'] && _vm.role['FmsCashiers'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
              name: 'Cashier',
              path: '/Fms/list-cashier',
            }}}):_vm._e()],1):_vm._e(),(
              (_vm.role['WorkshopAudits'] && _vm.role['WorkshopAudits'].menu == 1) ||
              (_vm.role['WorkshopDailyClosings'] &&
                _vm.role['WorkshopDailyClosings'].menu == 1) ||
              (_vm.role['WorkshopParkings'] &&
                _vm.role['WorkshopParkings'].menu == 1) ||
              (_vm.role['WorkshopParkingLines'] &&
                _vm.role['WorkshopParkingLines'].menu == 1) ||
              (_vm.role['WorkshopServiceCategories'] &&
                _vm.role['WorkshopServiceCategories'].menu == 1) ||
              (_vm.role['WorkshopServiceMasters'] &&
                _vm.role['WorkshopServiceMasters'].menu == 1) ||
              (_vm.role['WorkshopPartDealers'] &&
                _vm.role['WorkshopPartDealers'].menu == 1) ||
              (_vm.role['WorkshopProcurementOrders'] &&
                _vm.role['WorkshopProcurementOrders'].menu == 1) ||
              (_vm.role['WorkshopSparePartMasters'] &&
                _vm.role['WorkshopSparePartMasters'].menu == 1) ||
              (_vm.role['WorkshopClientMasters'] &&
                _vm.role['WorkshopClientMasters'].menu == 1) ||
              (_vm.role['WorkshopServiceEstimates'] &&
                _vm.role['WorkshopServiceEstimates'].menu == 1) ||
              (_vm.role['WorkshopPkbs'] && _vm.role['WorkshopPkbs'].menu == 1) ||
              (_vm.role['WorkshopFakturs'] &&
                _vm.role['WorkshopFakturs'].menu == 1) ||
              (_vm.role['WorkshopNotaParts'] &&
                _vm.role['WorkshopNotaParts'].menu == 1) ||
              (_vm.role['WorkshopNotaJasaBkls'] &&
                _vm.role['WorkshopNotaJasaBkls'].menu == 1)
          )?_c('sidebar-item',{attrs:{"link":{
            name: 'Workshop',
            icon: 'construction'
          }}},[_c('sidebar-item',{attrs:{"link":{
              name: 'Dashboard Workshop',
              icon: 'dashboard',
              path: '/workshop/dashboard',
            }}}),(_vm.role['WorkshopAudits'] && _vm.role['WorkshopAudits'].menu == 1)?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{ name: 'Audit' }}},[(
                _vm.role['WorkshopAudits'] && _vm.role['WorkshopAudits'].menu == 1
              )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
                name: 'Audit Sparepart',
                path: '/workshop/audit/list-audit-sparepart',
              }}}):_vm._e(),(
                _vm.role['WorkshopAudits'] && _vm.role['WorkshopAudits'].menu == 1
              )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{
                name: 'Audit Vehicle Sparepart',
                path: '/workshop/audit/list-audit-vehicle-sparepart',
              }}}):_vm._e()],1):_vm._e(),(
              _vm.role['WorkshopDailyClosings'] &&
                _vm.role['WorkshopDailyClosings'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Daily Closing',
              path: '/workshop/daily-closing/list-daily-closing',
            }}}):_vm._e(),(
              _vm.role['WorkshopParkings'] && _vm.role['WorkshopParkings'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Parking',
              path: '/workshop/parking/list-parking',
            }}}):_vm._e(),(
              _vm.role['WorkshopParkingLines'] &&
                _vm.role['WorkshopParkingLines'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Parking Line',
              path: '/workshop/parking-line/list-parking-line',
            }}}):_vm._e(),(
              _vm.role['WorkshopServiceCategories'] &&
                _vm.role['WorkshopServiceCategories'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Service Categories',
              path: '/workshop/service-categories/list-service-categories',
            }}}):_vm._e(),(
              _vm.role['WorkshopServiceMasters'] &&
                _vm.role['WorkshopServiceMasters'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Service Master',
              path: '/workshop/service-master/list-service-master',
            }}}):_vm._e(),(
              _vm.role['WorkshopPartDealers'] &&
                _vm.role['WorkshopPartDealers'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Part Dealer',
              path: '/workshop/part-dealer/list-part-dealer',
            }}}):_vm._e(),(
              _vm.role['WorkshopProcurementOrders'] &&
                _vm.role['WorkshopProcurementOrders'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Procurement Order',
              path: '/workshop/procurement-order/list-procurement-order',
            }}}):_vm._e(),(
              _vm.role['WorkshopSparePartMasters'] &&
                _vm.role['WorkshopSparePartMasters'].menu == 1
            )?_c('sidebar-item',{staticStyle:{"margin-left":"5mm !important"},attrs:{"link":{ name: 'Spare Part' }}},[(
                _vm.role['WorkshopSparePartMasters'] &&
                  _vm.role['WorkshopSparePartMasters'].menu == 1
              )?_c('sidebar-item',{attrs:{"link":{
                name: 'Spare Part Master',
                path: '/workshop/spare-part-master/list-spare-part-master',
              }}}):_vm._e(),(
                _vm.role['WorkshopSparePartRequests'] &&
                  _vm.role['WorkshopSparePartRequests'].menu == 1
              )?_c('sidebar-item',{attrs:{"link":{
                name: 'Spare Part Request',
                path: '/workshop/spare-part-request/list-spare-part-request',
              }}}):_vm._e(),(
                _vm.role['WorkshopSparePartTransfers'] &&
                  _vm.role['WorkshopSparePartTransfers'].menu == 1
              )?_c('sidebar-item',{attrs:{"link":{
                name: 'Spare Part Transfer',
                path:
                  '/workshop/spare-part-transfer/list-spare-part-transfer',
              }}}):_vm._e()],1):_vm._e(),(
              _vm.role['WorkshopClientMasters'] &&
                _vm.role['WorkshopClientMasters'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Client Master',
              path: '/workshop/client-master/list-client-master',
            }}}):_vm._e(),(
              _vm.role['WorkshopServiceEstimates'] &&
                _vm.role['WorkshopServiceEstimates'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Service Estimate',
              path: '/workshop/service-estimate/list-service-estimate',
            }}}):_vm._e(),(_vm.role['WorkshopPkbs'] && _vm.role['WorkshopPkbs'].menu == 1)?_c('sidebar-item',{attrs:{"link":{
              name: 'PKB',
              path: '/workshop/pkb/list-pkb',
            }}}):_vm._e(),(
              _vm.role['WorkshopFakturs'] && _vm.role['WorkshopFakturs'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Faktur',
              path: '/workshop/faktur/list-faktur',
            }}}):_vm._e(),(
              _vm.role['WorkshopNotaParts'] && _vm.role['WorkshopNotaParts'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Nota Part',
              path: '/workshop/nota-part/list-nota-part',
            }}}):_vm._e(),(
              _vm.role['WorkshopNotaJasaBkls'] &&
                _vm.role['WorkshopNotaJasaBkls'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
              name: 'Nota Jasa Bkl',
              path: '/workshop/nota-jasa-bkl/list-nota-jasa-bkl',
            }}}):_vm._e()],1):_vm._e(),(
              _vm.role['FinanceClicks'] &&
                _vm.role['FinanceClicks'].menu == 1
            )?_c('sidebar-item',{attrs:{"link":{
            name: 'Finance',
            icon: 'money'
          }}},[(
                _vm.role['FinanceClicks'] &&
                  _vm.role['FinanceClicks'].menu == 1
              )?_c('sidebar-item',{attrs:{"link":{
              name: 'Click',
              icon: 'money',
              path: '/finance/click/list-click',
            }}}):_vm._e()],1):_vm._e()],1)],2),_c('div',{staticClass:"main-panel"},[(_vm.user.notification)?_c('top-navbar',{attrs:{"notification":_vm.user.notification,"user":_vm.user}}):_vm._e(),_c('fixed-plugin',{attrs:{"color":_vm.sidebarBackground,"colorBg":_vm.sidebarBackgroundColor,"sidebarMini":_vm.sidebarMini,"sidebarImg":_vm.sidebarImg,"image":_vm.sidebarBackgroundImage},on:{"update:color":function($event){_vm.sidebarBackground=$event},"update:colorBg":function($event){_vm.sidebarBackgroundColor=$event},"update:color-bg":function($event){_vm.sidebarBackgroundColor=$event},"update:sidebarMini":function($event){_vm.sidebarMini=$event},"update:sidebar-mini":function($event){_vm.sidebarMini=$event},"update:sidebarImg":function($event){_vm.sidebarImg=$event},"update:sidebar-img":function($event){_vm.sidebarImg=$event},"update:image":function($event){_vm.sidebarBackgroundImage=$event}}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent }},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }